
import React, {PropsWithChildren} from 'react';
import ArticlePanel from 'components/ContentPagesComponents/ArticlePanel';
import {Interviewer} from 'components/ContentPagesComponents/Assistant/Interviewer';
import {SalesQualifier} from 'components/ContentPagesComponents/Assistant/SalesQualifier';
import {BookingWidget} from 'components/ContentPagesComponents/BookingWidget';
import BrandLogoActionRow, {BrandLogoImage} from 'components/ContentPagesComponents/BrandLogoActionRow';
import CardsSlider from 'components/ContentPagesComponents/CardsSlider';
import LocationCardItem from 'components/ContentPagesComponents/CardsSlider/CardsSliderItem/LocationCardItem';
import Charts from 'components/ContentPagesComponents/Charts';
import ChartBarChart from 'components/ContentPagesComponents/Charts/ChartBarChart';
import ChartDotsMatrix from 'components/ContentPagesComponents/Charts/ChartDotsMatrix';
import ChartDoughnut from 'components/ContentPagesComponents/Charts/ChartDoughnut';
import ClientsPanel from 'components/ContentPagesComponents/ClientsPanel';
import CoverImage from 'components/ContentPagesComponents/CoverImage';
import CoverShort from 'components/ContentPagesComponents/CoverShort';
import Divider from 'components/ContentPagesComponents/Divider';
import {DynamicWidget} from 'components/ContentPagesComponents/DynamicWidget/Loadable';
import ExitSurveyModal from 'components/ContentPagesComponents/ExitSurveyModal';
import FullRow from 'components/ContentPagesComponents/FullRow';
import HalfImageBigButton from 'components/ContentPagesComponents/HalfImageBigButton';
import HalfImageBlock from 'components/ContentPagesComponents/HalfImageBlock';
import ImagePanels from 'components/ContentPagesComponents/ImagePanels';
import ImagePanelItem from 'components/ContentPagesComponents/ImagePanels/ImagePanelItem';
import ImageRow from 'components/ContentPagesComponents/ImageRow';
import ImageRow2 from 'components/ContentPagesComponents/ImageRow2';
import InfoPanelRow from 'components/ContentPagesComponents/InfoPanelRow';
import InfoPanelRowItem from 'components/ContentPagesComponents/InfoPanelRow/InfoPanelRowItem';
import InfoPanelText from 'components/ContentPagesComponents/InfoPanelText';
import InfoPanelTextItem from 'components/ContentPagesComponents/InfoPanelText/InfoPanelTextItem';
import LaptopSizeWrapper from 'components/ContentPagesComponents/LaptopSizeWrapper';
import LatestBlogItems from 'components/ContentPagesComponents/LatestBlogItems';
import LeadCapture from 'components/ContentPagesComponents/LeadCapture';
import MediaLogoRow from 'components/ContentPagesComponents/MediaLogoRow';
import {PaddedWrapper} from 'components/ContentPagesComponents/PaddedWrapper';
import PanelWithAccordions from 'components/ContentPagesComponents/PanelWithAccordions';
import AccordionItem from 'components/ContentPagesComponents/PanelWithAccordions/AccordionItem';
import PanelWithTabs from 'components/ContentPagesComponents/PanelWithTabs';
import PanelTabItem from 'components/ContentPagesComponents/PanelWithTabs/PanelTabItem';
import PartnerBooking from 'components/ContentPagesComponents/PartnerBooking';
import {PricingList} from 'components/ContentPagesComponents/PricingList';
import {SampleReport} from 'components/ContentPagesComponents/SampleReport';
import {ScrollLogos} from 'components/ContentPagesComponents/ScrollSlowly/ScrollLogos';
import {Testimonials} from 'components/ContentPagesComponents/ScrollSlowly/Testimonials';
import SiteReviews from 'components/ContentPagesComponents/SiteReviews';
import SiteReviewsItem from 'components/ContentPagesComponents/SiteReviews/SiteReviewsItem';
import StandardWrapper from 'components/ContentPagesComponents/StandardWrapper';
import StepsReviewer from 'components/ContentPagesComponents/StepsReviewer';
import StepsReviewItem from 'components/ContentPagesComponents/StepsReviewer/StepsReviewItem';
import TextHeader from 'components/ContentPagesComponents/TextHeader';
import TextOnly from 'components/ContentPagesComponents/TextOnly';
import TextOverImages from 'components/ContentPagesComponents/TextOverImages';
import TextOverImageItem from 'components/ContentPagesComponents/TextOverImages/TextOverImageItem';
import TypeForm from 'components/ContentPagesComponents/TypeForm';
import UserReviews from 'components/ContentPagesComponents/UserReviews';
import UserReviewsItem from 'components/ContentPagesComponents/UserReviews/UserReviewsItem';
import Video from 'components/ContentPagesComponents/Video';
import {VoiceAgent} from 'components/ContentPagesComponents/VoiceAgent';
import WaitList from 'components/ContentPagesComponents/WaitList';
import WaitListCoverImage from 'components/ContentPagesComponents/WaitListCoverImage';
import DynamicAsset from 'components/DynamicAsset';
import {DOMNode, domToReact, Element as ParserElement, HTMLReactParserOptions} from 'html-react-parser';
import {FirstLookCard} from 'pages/dashboard/components/FirstLook/Card';

const ComponentMap = {
	AccordionItem: AccordionItem,
	ArticlePanel: ArticlePanel,
	BookingWidget: BookingWidget,
	BrandLogoActionRow: BrandLogoActionRow,
	BrandLogoImage: BrandLogoImage,
	CardsSlider: CardsSlider,
	ChartBarChart: ChartBarChart,
	ChartDotsMatrix: ChartDotsMatrix,
	ChartDoughnut: ChartDoughnut,
	Charts: Charts,
	ClientsPanel: ClientsPanel,
	CoverImage: CoverImage,
	CoverShort: CoverShort,
	Divider: Divider,
	DynamicAsset: DynamicAsset,
	DynamicWidget: DynamicWidget,
	ExitSurveyModal: ExitSurveyModal,
	FirstLook: FirstLookCard,
	FullRow: FullRow,
	HalfImageBigButton: HalfImageBigButton,
	HalfImageBlock: HalfImageBlock,
	ImagePanelItem: ImagePanelItem,
	ImagePanels: ImagePanels,
	ImageRow2: ImageRow2,
	ImageRow: ImageRow,
	InfoPanelRow: InfoPanelRow,
	InfoPanelRowItem: InfoPanelRowItem,
	InfoPanelText: InfoPanelText,
	InfoPanelTextItem: InfoPanelTextItem,
	Interviewer: Interviewer,
	LaptopSizeWrapper: LaptopSizeWrapper,
	LatestBlogItems: LatestBlogItems,
	LeadCapture: LeadCapture,
	LocationCardItem: LocationCardItem,
	MediaLogoRow: MediaLogoRow,
	PaddedWrapper: PaddedWrapper,
	PanelTabItem: PanelTabItem,
	PanelWithAccordions: PanelWithAccordions,
	PanelWithTabs: PanelWithTabs,
	PartnerBooking: PartnerBooking,
	PricingList: PricingList,
	SalesQualifier: SalesQualifier,
	SampleReport : SampleReport,
	ScrollLogos: ScrollLogos,
	SiteReviews: SiteReviews,
	SiteReviewsItem: SiteReviewsItem,
	StandardWrapper: StandardWrapper,
	StepsReviewItem: StepsReviewItem,
	StepsReviewer: StepsReviewer,
	Testimonials: Testimonials,
	TextHeader: TextHeader,
	TextOnly: TextOnly,
	TextOverImageItem: TextOverImageItem,
	TextOverImages: TextOverImages,
	TypeForm: TypeForm,
	UserReviews: UserReviews,
	UserReviewsItem: UserReviewsItem,
	Video: Video,
	VoiceAgent: VoiceAgent,
	WaitList: WaitList,
	WaitListCoverImage: WaitListCoverImage,
};

type Replacer = HTMLReactParserOptions['replace'];

export const ComponentResolver: Replacer = (domNode: DOMNode) => {
	const elemNode = domNode as ParserElement;
	const tagName = elemNode.tagName as (keyof typeof ComponentMap);
	const Component = ComponentMap[tagName] as React.FC<PropsWithChildren> | undefined;

	if (!Component) {
		return domNode;
	}

	let children: React.ReactNode = '';
	if (elemNode.children && elemNode.children.length > 0) {
		children = domToReact(elemNode.children as DOMNode[], {
			trim: true,
			replace: ComponentResolver,
		});
	}

	return (
		<Component {...elemNode.attribs}>
			{children}
		</Component>
	);
};
